module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Bold.ttf?b02188fb003c069359c4f5adebc7e1ed";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Bold.ttf
// module id = 1426
// module chunks = 0